function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "fikzax_new_nobckg_v01-a",
  x: "-4.3%",
  y: "-1.7%",
  width: "112.3%",
  height: "104.8%"
}, React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("ellipse", {
  cx: 223,
  cy: 137.82,
  rx: 223,
  ry: 137.82,
  fill: "#4527A0"
}), React.createElement("polygon", {
  transform: "translate(0,-45)",
  points: "62.179 222 126 278.56 14 312",
  fill: "#4527A0"
}), React.createElement("g", {
  transform: "translate(0,-45)",
  fill: "#9575CD"
}, React.createElement("g", {
  filter: "url(#fikzax_new_nobckg_v01-a)",
  "aria-label": "Z"
}, React.createElement("path", {
  d: "m296.41 127.04q-6.5796 4.0674-16.15 10.408-20.217 14.954-47.852 51.44-21.174 28.472-42.349 57.063l-0.47852 0.59814q8.7329-0.23925 42.109-1.6748 26.199-1.1963 41.75-1.1963 17.107 0 23.208 1.3159 14.355 3.1104 14.834 13.757 0.35889 7.8955-5.5029 12.441-5.0244 3.9478-12.083 3.9478-3.4692 0-10.408-0.47851-6.9385-0.35889-10.408-0.35889-18.184 0-54.67 0.8374-36.367 0.95703-54.551 0.95703-7.7759 0-12.8-3.9478-5.6226-4.3066-5.6226-12.083 0-8.6133 7.5366-20.457 2.3926-3.7085 13.518-18.064 19.619-26.199 39.358-52.278 23.447-30.146 43.904-48.809-18.662 1.3159-28.472 1.3159h-48.33q-1.3159 0-3.8281 0.23925-2.5122 0.11963-3.8281 0.11963-7.0581 0-11.963-4.0674-5.5029-4.5459-5.5029-12.202 0-16.389 24.285-16.389 8.2544 0 24.644 1.0767 16.389 0.95703 24.644 0.95703 9.2114 0 27.515-0.47852 18.423-0.47852 27.634-0.47852 35.649 0 35.649 15.552 0 9.9292-15.791 20.935z"
})), React.createElement("g", {
  "aria-label": "Z"
}, React.createElement("path", {
  d: "m296.41 127.04q-6.5796 4.0674-16.15 10.408-20.217 14.954-47.852 51.44-21.174 28.472-42.349 57.063l-0.47852 0.59814q8.7329-0.23925 42.109-1.6748 26.199-1.1963 41.75-1.1963 17.107 0 23.208 1.3159 14.355 3.1104 14.834 13.757 0.35889 7.8955-5.5029 12.441-5.0244 3.9478-12.083 3.9478-3.4692 0-10.408-0.47851-6.9385-0.35889-10.408-0.35889-18.184 0-54.67 0.8374-36.367 0.95703-54.551 0.95703-7.7759 0-12.8-3.9478-5.6226-4.3066-5.6226-12.083 0-8.6133 7.5366-20.457 2.3926-3.7085 13.518-18.064 19.619-26.199 39.358-52.278 23.447-30.146 43.904-48.809-18.662 1.3159-28.472 1.3159h-48.33q-1.3159 0-3.8281 0.23925-2.5122 0.11963-3.8281 0.11963-7.0581 0-11.963-4.0674-5.5029-4.5459-5.5029-12.202 0-16.389 24.285-16.389 8.2544 0 24.644 1.0767 16.389 0.95703 24.644 0.95703 9.2114 0 27.515-0.47852 18.423-0.47852 27.634-0.47852 35.649 0 35.649 15.552 0 9.9292-15.791 20.935z"
})), React.createElement("g", {
  "aria-label": "Z"
}, React.createElement("path", {
  d: "m296.41 127.04q-6.5796 4.0674-16.15 10.408-20.217 14.954-47.852 51.44-21.174 28.472-42.349 57.063l-0.47852 0.59814q8.7329-0.23925 42.109-1.6748 26.199-1.1963 41.75-1.1963 17.107 0 23.208 1.3159 14.355 3.1104 14.834 13.757 0.35889 7.8955-5.5029 12.441-5.0244 3.9478-12.083 3.9478-3.4692 0-10.408-0.47851-6.9385-0.35889-10.408-0.35889-18.184 0-54.67 0.8374-36.367 0.95703-54.551 0.95703-7.7759 0-12.8-3.9478-5.6226-4.3066-5.6226-12.083 0-8.6133 7.5366-20.457 2.3926-3.7085 13.518-18.064 19.619-26.199 39.358-52.278 23.447-30.146 43.904-48.809-18.662 1.3159-28.472 1.3159h-48.33q-1.3159 0-3.8281 0.23925-2.5122 0.11963-3.8281 0.11963-7.0581 0-11.963-4.0674-5.5029-4.5459-5.5029-12.202 0-16.389 24.285-16.389 8.2544 0 24.644 1.0767 16.389 0.95703 24.644 0.95703 9.2114 0 27.515-0.47852 18.423-0.47852 27.634-0.47852 35.649 0 35.649 15.552 0 9.9292-15.791 20.935z"
}))), React.createElement("g", {
  fill: "#fff",
  "aria-label": "fik"
}, React.createElement("path", {
  d: "m93.006 107.3h-0.41992q-1.3018-0.37793-3.4014-0.75585-2.0996-0.41993-3.6953-0.41993-5.0811 0-7.3906 2.2676-2.2676 2.2256-2.2676 8.1045v1.5957h14.235v6.6348h-13.983v40.271h-7.8945v-40.271h-5.333v-6.6348h5.333v-1.5537q0-8.3564 4.1572-12.808 4.1572-4.4932 12.01-4.4932 2.6455 0 4.7451 0.25195 2.1416 0.25195 3.9053 0.58789z"
}), React.createElement("path", {
  d: "m106.49 110.24h-8.9023v-8.1885h8.9023zm-0.5039 54.758h-7.8945v-46.905h7.8945z"
}), React.createElement("path", {
  d: "m164.27 165h-10.414l-18.812-20.534-5.123 4.8711v15.663h-7.8945v-65.34h7.8945v41.908l22.802-23.474h9.9522l-21.794 21.668z"
})), React.createElement("g", {
  fill: "#fff",
  "aria-label": "ax"
}, React.createElement("path", {
  d: "m317.22 162h-7.8525v-4.9971q-1.0498 0.71387-2.8555 2.0156-1.7637 1.2598-3.4434 2.0156-1.9736 0.96582-4.5352 1.5957-2.5615 0.67188-6.0049 0.67188-6.3408 0-10.75-4.1992t-4.4092-10.708q0-5.333 2.2676-8.6084 2.3096-3.3174 6.5508-5.207 4.2832-1.8896 10.288-2.5615 6.0049-0.67188 12.892-1.0078v-1.2178q0-2.6875-0.96582-4.4512-0.92382-1.7637-2.6875-2.7715-1.6797-0.96582-4.0312-1.3018-2.3516-0.33594-4.9131-0.33594-3.1074 0-6.9287 0.83984-3.8213 0.79786-7.8945 2.3516h-0.41993v-8.0205q2.3096-0.62988 6.6768-1.3857t8.6084-0.75586q4.9551 0 8.6084 0.83984 3.6953 0.79785 6.3828 2.7715 2.6455 1.9316 4.0312 4.9971t1.3857 7.6006zm-7.8525-11.548v-13.06q-3.6113 0.20996-8.5244 0.62988-4.8711 0.41992-7.7266 1.2178-3.4014 0.96582-5.501 3.0234-2.0996 2.0156-2.0996 5.585 0 4.0312 2.4356 6.0889 2.4356 2.0156 7.4326 2.0156 4.1572 0 7.6006-1.5957 3.4434-1.6377 6.3828-3.9053z"
}), React.createElement("path", {
  d: "m373.11 162h-9.9521l-13.312-18.015-13.396 18.015h-9.1963l18.309-23.39-18.141-23.516h9.9522l13.228 17.721 13.27-17.721h9.2383l-18.435 23.096z"
})));

var SvgFikzaxlogo = function SvgFikzaxlogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 446,
    height: 276,
    viewBox: "0 0 446 276",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFikzaxlogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fikzaxlogo.cbad90c1.svg";
export { ForwardRef as ReactComponent };